<div class="container-fluid">
  <div class="row">
    <div class="col p-0">
      <router-outlet></router-outlet>
      <p-toast position="top-right" life="10000" [baseZIndex]="100000" (onClose)="messageService.clear()">
        <ng-template let-message let-message #message>
          <div>
            <div class="toast-summary" [innerHtml]="message.summary"></div>
            <div class="mt-2" [innerHtml]="message.detail" *ngIf="message.detail"></div>
          </div>
        </ng-template>
      </p-toast>
      <app-loader></app-loader>
      <p-confirmDialog
        [closeOnEscape]="true"
        [closable]="false"
        [baseZIndex]="10000"
        appendTo="body"
        draggable="false"
        [styleClass]="appGlobalService.isBetaAccessPrivilegeConsumable() ? 'beta-access-enabled' : ''"
      ></p-confirmDialog>
      <p-confirmDialog
        [closeOnEscape]="true"
        [closable]="false"
        [baseZIndex]="10000"
        appendTo="body"
        key="noReferencesDialog"
        [styleClass]="appGlobalService.isBetaAccessPrivilegeConsumable() ? 'beta-access-enabled' : ''"
      >
        <ng-template pTemplate="header">
          <div class="no-reference-dialog-header">
            <i class="pi pi-info-circle"></i>
            <span>{{ 'NO_USAGE_FOUND' | translate }}</span>
          </div>
        </ng-template>
      </p-confirmDialog>
      <!-- Merge Status Confirmation Dialog - Non-closable -->
      <p-confirmDialog
        key="mergeStatusPopup"
        [closable]="false"
        [closeOnEscape]="false"
        [baseZIndex]="100000"
        appendTo="body"
        [styleClass]="appGlobalService.isBetaAccessPrivilegeConsumable() ? 'merge-status-popup beta-access-enabled' : 'merge-status-popup'">
        <ng-template #message let-message>
          <div [innerHTML]="message.message"></div>
        </ng-template>
      </p-confirmDialog>
      <app-console-error-panel></app-console-error-panel>
      <!-- <app-console-error-panel></app-console-error-panel> -->
    </div>
  </div>
</div>
<p-dialog [visible]="isOffLine" position="top" [header]="'NETWORK_STATUS' | translate" [appendTo]="'body'" styleClass="copy-txt-pop" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false">
  <p>{{ 'INTERNET_CONNECTION_DOWN' | translate }}</p>
</p-dialog>
